module.exports = __webpack_public_path__ + "img/documents-dashboard-icon.aadd210.png";